import { type DatabaseChangeType } from '@databases/types/redux';

import { getValueId } from '../../../../utils';
import { type YJSChangeHandler } from '../../types';

export const deleteEntry: YJSChangeHandler<DatabaseChangeType.DELETE_ENTRY> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    db.deleteEntry(change.entryId);

    // Remove all comments on the entry
    db.fields.forEach((fieldId: string) => {
      const valueId = getValueId(change.entryId, fieldId);
      if (valueId in db.commentThreads) {
        db.removeCommentsOnValue(valueId);
      }
    });
  });
};
